import { MarketplaceCartItemSchema } from "@redotech/redo-model/recommerce/marketplace-cart";
import * as z from "zod";

export const doBulkPurchase = {
  name: "doBulkPurchase" as const,
  input: z.object({
    cartItems: z.array(MarketplaceCartItemSchema),
    customerEmail: z.string().optional(),
    currency: z.string().default("USD"),
  }),
  output: z.object({
    checkoutUrl: z.string(),
    sessionId: z.string(),
    totalAmount: z.number(),
    marketplaceOrderId: z.string(),
    merchantOrderIds: z.array(z.string()),
    productCount: z.number(),
    totalQuantity: z.number(),
  }),
};
